import Founder1 from '../assets/img/Founders/Founder1.webp'
import Founder2 from '../assets/img/Founders/Founder2.webp'
const founders = [
    {
      name: 'Michele Isaac Giuseppe',
      position: 'Board Chairman',
      images:  Founder1
    },
    {
      name: 'Meaza Zare Yohanees',
      position: 'General Manager',
      images: Founder2
    }
  
  
  ];

  export default founders;